"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSubcategory = exports.SUBCATEGORY_UNLISTED = void 0;
const subcat_type_1 = require("./subcat_type");
exports.SUBCATEGORY_UNLISTED = 'unlisted';
function mockSubcategory(overrides = {}) {
    return {
        description: 'mock description',
        display_name: 'mock display_name',
        display_order: 0,
        id: 1,
        image: 'http://example.com/image.jpg',
        img_alt: 'mock img_alt',
        meta_description: 'mock meta_description',
        meta_title: 'mock meta_title',
        name: 'mock_subcategory_name',
        nav_hidden: false,
        page_heading: 'mock page_heading',
        page_subheading: 'mock page_subheading',
        subcat_types: [(0, subcat_type_1.mockSubcatType)()],
        url_path: 'mock_url_path',
        ...overrides,
    };
}
exports.mockSubcategory = mockSubcategory;
